import React, { forwardRef, useImperativeHandle, useState } from "react";
import { FormControl, FormErrorMessage, FormLabel, Select } from "@chakra-ui/react";
import Option from "../../interfaces/Option";
import RequiredMark from "./RequiredMark";

interface InputSelectProps {
  label: string;
  placeholderText: string;
  options: Array<Option>;
  isRequired: boolean;
  initValue: Option | undefined;
  getSelectedOption: (value: Option | undefined) => void;
}

const InputSelectRequired = forwardRef((props: InputSelectProps, ref) => {

  const [selectedOption, setSelectedOption] = useState<Option | undefined>(props.initValue);
  const [error, setError] = useState<string>("");

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let currentOption = props.options.find(option => option.value === event.target.value);
    setSelectedOption(currentOption);
    props.getSelectedOption(currentOption);
  };

  const validateSelectedOption = () => {
    if (props.isRequired && !selectedOption) {
        setError(`Nie wybrano żadnej opcji`);
        return false;
    } else {
        setError("");
        return true;
    }
};

  useImperativeHandle(ref, () => ({
    validate: () => validateSelectedOption(),
  }));

  return (
    <FormControl isInvalid={!!error}
      mt="5"
    >
      <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
      <Select
        placeholder={props.placeholderText}
        value={selectedOption?.value}
        onChange={handleSelectChange}
        onBlur={validateSelectedOption}
      >
        {props.options.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </Select>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
});

export default InputSelectRequired;